const primary = ({ primaryColor, backgroundColor, whiteColor }) =>
  backgroundColor.equals(primaryColor) ? primaryColor : whiteColor;

export default primary;
